import BaseInputField from './BaseInputField';

class CheckboxField extends BaseInputField {
	_resetValue() {
		const input = this._$input.get(0);

		if (input && input.checked) {
			input.checked = false;
		}
	}

	getValue() {
		const input = this._$input.get(0);
		const value = input && input.checked ? '1' : '';

		return value;
	}

	_getLabel() {
		const input = this._$input.get(0);
		return input ? input.checked : '';
	}

	setValueAndTriggerEvent(filterValue) {
		if (this._$input.length) {
			this.setValue(filterValue);
			this._$input.trigger('change');
		}
	}

	setValue(filterValue) {
		const checkbox = this._$input.get(0);

		if (checkbox) {
			const booleanFilterValue = (filterValue === '0' || filterValue === 0 || !filterValue) ? false : true;
			checkbox.checked = booleanFilterValue;
		}
	}
}

export default CheckboxField;
